module.exports = __webpack_public_path__ + "static/media/upper.bda21440.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/upper.svg
// module id = 208
// module chunks = 0